'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.inviteAFriendOnEnter = inviteAFriendOnEnter;

var _effects = require('redux-saga/effects');

var _sagaTools = require('@classpass/saga-tools');

var _bound = require('redux/saga/entities/bound');

var _user = require('redux/saga/selectors/user');

var _deep = require('helpers/deep');

var _InviteAFriend = require('./InviteAFriend.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(inviteAFriendOnEnter);

function inviteAFriendOnEnter(client, nextState, replaceState) {
  var finalDestination, loggedIn, token, _ref, schedule, studioAlias, classAlias;

  return _regenerator2.default.wrap(function inviteAFriendOnEnter$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          finalDestination = '/classes';
          _context.next = 3;
          return (0, _effects.select)(_user.isLoggedIn);

        case 3:
          loggedIn = _context.sent;
          token = (0, _deep.deepExtract)('params.token', nextState);

          if (!(loggedIn && !token)) {
            _context.next = 9;
            break;
          }

          _context.next = 8;
          return (0, _effects.call)(replaceState, finalDestination);

        case 8:
          return _context.abrupt('return', _context.sent);

        case 9:
          _context.prev = 9;
          _context.next = 12;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userActionCampaign, [client, token], { key: token });

        case 12:
          _ref = _context.sent;
          schedule = _ref.schedule;

          if (!loggedIn) {
            _context.next = 20;
            break;
          }

          studioAlias = (0, _deep.deepExtract)('venue.alias', schedule);
          classAlias = (0, _deep.deepExtract)('class.alias', schedule);

          finalDestination = '/studios/' + studioAlias + '/' + classAlias + '/' + schedule.id;
          _context.next = 20;
          return (0, _effects.call)(replaceState, finalDestination);

        case 20:
          _context.next = 31;
          break;

        case 22:
          _context.prev = 22;
          _context.t0 = _context['catch'](9);

          if (!loggedIn) {
            _context.next = 29;
            break;
          }

          _context.next = 27;
          return (0, _effects.call)(replaceState, finalDestination);

        case 27:
          _context.next = 31;
          break;

        case 29:
          _context.next = 31;
          return (0, _effects.put)((0, _InviteAFriend.loadInviteAFriendError)(_context.t0));

        case 31:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[9, 22]]);
}